export default __webpack_public_path__ + "static/media/wrong.49af96dd.gif";